<template>
    <div class="head-cart" v-bind:class="{ opened: open }">
        <div class="head-cart-container">
            <div class="head-cart-title">
                {{ strings['shopping_bag'] }} <span id="close-panel" v-on:click="$emit('close-cart')"
                    class="close-panel"><i class="fal fa-times"></i></span>
            </div>
            <div class="head-cart-empty-message" v-if="loading === false && empty != false"
                v-bind:class="{ empty: empty === true || empty === null }">{{ strings['empty_cart'] }}</div>
            <div class="head-cart-items-content-list" v-if="loading === false && empty == false"
                v-bind:class="{ show: empty === false }">
                <div class="head-cart-items-list">
                    <cart-item v-for="(product, key) in cart.items" v-bind:product="product"
                        v-bind:currency="cart.currency" v-bind:strings="strings" v-bind:key="key"
                        v-on:remove="$emit('remove-item', key)"></cart-item>
                </div>
                <div class="head-cart-totals text-right">
                    <div class="head-cart-totals-subtotal row"
                        v-bind:class="{ 'head-cart-totals-total': !cart.promoCheck }">
                        <div class="col-xs-5 text-uppercase">{{ strings['subtotal'] }}</div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-5">{{ cart.currency }} {{ cart.subtotal.toFixed(2) }}</div>
                    </div>
                    <div class="head-cart-totals-promo-cost row" v-if="cart.promoCheck">
                        <div class="col-xs-5">{{ cart.promoCode }}</div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-5">{{ cart.currency }} - {{ cart.subtotalPromo.toFixed(2) }}</div>
                    </div>
                    <div class="head-cart-totals-total row" v-if="cart.promoCheck">
                        <div class="col-xs-5">{{ cart.currency }} {{ strings['total'] }}</div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-5">{{ cart.currency }} {{ cart.totalOutShippingCost.toFixed(2) }}</div>
                    </div>
                    <div class="head-cart-totals-info row tr" v-if="shippingrussian === true">
                        <div class="col-xs-12" v-html="strings['shipping_russian']"></div>
                    </div>
                    <div class="head-cart-totals-info row tr" v-if="activebuy === false">
                        <div class="col-xs-12">{{ strings['minimum_order_gb'] }}</div>
                    </div>
                </div>
                <div class="head-cart-action-btn" v-if="activebuy === true">
                    <a class="btn btn-primary" v-bind:href="api['summary']">{{ strings['go_to_checkout'] }}</a>
                    <a class="mt3 btn btn-white" v-bind:href="api['go_to_cart']">{{ strings['go_to_cart'] }}</a>
                </div>
            </div>
            <div class="tc head-cart-loading" v-if="loading === true">
                <div class="head-cart-loading-flex">
                    <div class="loader">Loading...</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CartItem from './CartItem.vue'

export default {
    props: [
        'open',
        'strings',
        'empty',
        'cart',
        'api',
        'loading',
        'lang',
        'activebuy',
        'shippingrussian',
    ],
    components: {
        'cart-item': CartItem,
    }
}
</script>
